/**
 * ©2021 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
 * Bangalore, India. All Rights Reserved.
 */
import "./elements-applaunch.js";
import { IronOverlayManager } from "../node_modules/@polymer/iron-overlay-behavior/iron-overlay-manager.js";

let templateLoader = (name) => {
  // /* webpackPrefetch: true */
  // /* webpackInclude: /\.js$/ */

  const testFolder = "../templates/";
  fs.readdir(testFolder, (err, files) => {
    files.forEach((file) => {
      if (file.slice(-3) == ".js") {
        import(
          /* webpackChunkName: "templates/[request]" */ `../templates/${name}`
        ).then((e) => {});
      }
    });
  });
};

/* Global Function to import template JSON configurations from local DB*/
window.importComponent = (compName, cb) => {
  let file_url = "/api/UIComponents/component/" + compName;
  file_url = file_url + "?tenantId=" + sessionStorage.tenantId;
  import(/* webpackIgnore: true */ OEUtils.geturl(file_url)).then((e) => {
    cb();
    __webpack_require__(compName);
  });
};
/*This event will get triggered when browser reload button is clicked.
If user is loggedin and application is reloaded , then session will expire and 
authorization token is deleted.
*/
window.onbeforeunload = function () {
  if (sessionStorage["auth_token"]) {
    var objData = {
      header: {},
      data: {
        "tenantId": sessionStorage.tenantId
      }
    }
    var ajaxCall = document.createElement('oe-ajax');
    ajaxCall.contentType = "application/json";
    ajaxCall.handleAs = "json";
    ajaxCall.url = "api/CBUsers/logout?=" + sessionStorage["auth_token"];
    ajaxCall.method = 'post';
    ajaxCall.body = objData;
    ajaxCall.generateRequest();
  } else {
    sessionStorage.clear()
  }
};

/* Common functions to be loaded initially*/
window.onload = () => {
  // const lazyAlertBtn = document.querySelector("#lazyAlert");
  // lazyAlertBtn.addEventListener("click", () => {
  //     import(/* webpackChunkName: "lazyLoaded" */ './lazyLoaded').then(module => {
  //         module.showLazyAlert();
  //     });
  // });

  /* Function to slice template name and load the template*/
  window.importUIComponent = function (url, onload_cb) {
    let name = url.replace("/api/UIComponents/component/", "");
    return importComponent(name, onload_cb);
    // url = window.localStorage.baseurl + url;
    // url = url + "?tenantId=" + sessionStorage.tenantId;
    // import(url).then(function (e) {
    //     onload_cb.call();
    // });
  };

  /* Global function to load elements/third party js all over the application*/
  window.addImportLink = function (url, asyncFlg, onload_cb) {
    import(url).then(function (e) {
      onload_cb.call();
    });
  };
  // start of changes for 265213 issue fix
  //using jquery explicitly to handle browser back button issue
  window.onpopstate = function () {
    var mainbody = document.getElementById("mainbody");
    if (performance.navigation.TYPE_BACK_FORWARD == 2) {
      /*below code is added if back button is clicked in browser , the session will
       expire and authorization token will get deleted.
      */
      var objData = {
        header: {},
        data: {
          "tenantId": sessionStorage.tenantId
        }
      }
      var ajaxCall = document.createElement('oe-ajax');
      ajaxCall.contentType = "application/json";
      ajaxCall.handleAs = "json";
      ajaxCall.url = "api/CBUsers/logout?=" + sessionStorage["auth_token"];
      ajaxCall.method = 'post';
      ajaxCall.body = objData;
      ajaxCall.generateRequest();
      // addImportLink('./node_modules/speedboat_ui/elements/session-expire-msg.js', true, function () {
      // });
      import(
        /* webpackChunkName: "session-expire-msg" */ "../node_modules/speedboat_ui/elements/session-expire-msg.js"
      ).then(() => {});
      var role = clientStorage.get(storageType.session, "role");
      sessionStorage.clear();
      mainbody.selected = 14;
      mainbody.loggedin = false;
      mainbody.shoppingMallLoggedin = false;
      mainbody.role = role;
      window.removeListners();
    }
  };
  // end of changes for 265213 issue fix
  //this allows to add imports without blocking page rendering.
  setTimeout(function () {
    var mbody = document.getElementById("mainbody");
    console.debug("async import started...");
    import(
      /* webpackChunkName: "elements-common" */ "./elements-common.js"
    ).then(() => {
      console.debug("common async import loaded!!!");
      mbody.asyncImportsLoaded = true;
      mbody.asyncScriptsLoaded = true;
      document.dispatchEvent(new Event("async-imports-loaded"));
    });
    // import(/* webpackChunkName: "elements-direct-banking" */ '../node_modules/sb_directbanking_ui/elements/elements-direct-banking.js').then(() => {
    //     console.debug('retail direct-banking elements import loaded!!!');
    // });
    // import(/* webpackChunkName: "elements-locator" */ '../node_modules/speedboat_ui/elements/elements-locator.js').then(() => {
    //     console.debug('retail locator elements import loaded!!!');
    // });
    // addImportLink('./elements/elements-common.js', true, function () {
    //     console.debug('common async import loaded!!!');
    //     mbody.asyncImportsLoaded = true;
    //     mbody.asyncScriptsLoaded = true;
    //     document.dispatchEvent(new Event('async-imports-loaded'));
    // });
  }, 0);
  import(
    /* webpackChunkName: "session-expire-msg" */ "../node_modules/speedboat_ui/elements/session-expire-msg.js"
  ).then(() => {
    console.debug("session expire msg import loaded!!!");
  });

  //add dashboard element imports when login request is inotiated. The login-req event is fired in ev-login
  document.addEventListener("login-req", function () {
    var mbody = document.getElementById("mainbody");
    var loginData = mbody.loginModeData;
    //Function definition is present in common.js and should be changed in each implementation based on deployment
    var userType = checkCorporateOrRetailUser(loginData);
    /*
     * Below function upload client performance logs in speedboat DB
     * @param {eventType} Name of event on which we are uploading data.
     **/

    //  function uploadPerformanceClientLogs() {
    //    let performanceData = performance.getEntriesByType("navigation");
    //    let ajaxPost = document.createElement("oe-ajax");
    //    ajaxPost.contentType = "application/json";
    //    ajaxPost.handleAs = "json";
    //    ajaxPost.url = "/api/ClientLogs";
    //    ajaxPost.method = "POST";
 
    //    var chromeAgent = getNavigationItem("userAgent").indexOf("Chrome") > -1;
    //    var IExplorerAgent =
    //      getNavigationItem("userAgent").indexOf("MSIE") > -1 ||
    //      getNavigationItem("userAgent").indexOf("rv:") > -1;
    //    var firefoxAgent = getNavigationItem("userAgent").indexOf("Firefox") > -1;
    //    var edgeAgent = getNavigationItem("userAgent").indexOf("Edg") > -1;
    //    var safariAgent = getNavigationItem("userAgent").indexOf("Safari") > -1;
    //    if (IExplorerAgent && firefoxAgent) IExplorerAgent = false;
    //    // Discard safari and chrome because it also matches with edge
    //    else if (edgeAgent && safariAgent && chromeAgent) {
    //      chromeAgent = false;
    //      safariAgent = false;
    //    }
    //    // Discard Safari since it also matches Chrome
    //    else if (chromeAgent && safariAgent) safariAgent = false;
    //    var uAgent;
    //    if (chromeAgent) {
    //      uAgent = "chrome";
    //    } else if (safariAgent) {
    //      uAgent = "safari";
    //    } else if (firefoxAgent) {
    //      uAgent = "Firefox";
    //    } else if (edgeAgent) {
    //      uAgent = "Edge";
    //    } else if (IExplorerAgent) {
    //      uAgent = "IExplorer";
    //    } else {
    //      var iphone =
    //        getNavigationItem("userAgent").match(/(iPhone|iPod|iPad)/) || false;
    //      if (iphone) uAgent = "iphone";
    //      else {
    //        var android =
    //          getNavigationItem("userAgent").match(/Android/) || false;
    //        if (android) uAgent = "android";
    //        else uAgent = "_";
    //      }
    //    }
    //    var correlationID = {
    //      uuid: sessionStorage.getItem("uuid"),
    //      resId: uuidv4(),
    //      resName: (window.OEUtils.baseurl + "/api/ClientLogs")
    //        .split("/")
    //        .slice(4)
    //        .join("/"),
    //      menuId: window.menuId ? window.menuId : "N.A",
    //      buttonId: window.buttonId ? window.buttonId : "N.A",
    //    };
    //    ajaxPost.body = {
    //      ActivityName: "application-launching",
    //      LogOrigin: window.location.href,
    //      UserType: userType || "Not Logged In Page",
    //      UserAgent: uAgent,
    //      User: loginData ? loginData.userId : mbody.username,
    //      CorrelationID: correlationID,
    //      LogData: performanceData,
    //      Timestamp: new Date(),
    //    };
 
    //    ajaxPost.addEventListener("response", function (event) {});
    //    ajaxPost.addEventListener("error", function (err) {
    //      showAjaxError(err);
    //    });
    //    ajaxPost.generateRequest();
    //  }
    //  // This is used for testing the UploadPerformanceClientLogs function for getting the timing
    //  if (config.SpeedBoat.App.uplodPerformanceLogsToDb === true) {
    //    uploadPerformanceClientLogs();
    //  }
    //Commenting as this call is moved to ev-login
    
    if (
      config.SpeedBoat.Modules.subApp &&
      config.SpeedBoat.Modules.subApp.enabled
    ) {
      getSubApps();
      import(
        /* webpackChunkName: "sb-wm-integrator" */ "../node_modules/sb_wm_integrator/dist/sb-wm-integrator.js"
      ).then(function () {
        console.debug(
          "Wavemaker Speedboat Integration Script Import loaded!!!"
        );
      });
    }

    import(
      /* webpackChunkName: "log-out-landing" */ "../node_modules/speedboat_ui/elements/log-out-landing.js"
    ).then(() => {
      console.debug("retail log-out-landing elements import loaded!!!");
    });
    import(
      /* webpackChunkName: "error-msg" */ "../node_modules/speedboat_ui/elements/error-msg.js"
    ).then(() => {
      console.debug("error-msg import loaded!!!");
    });
    import(
      /* webpackChunkName: "app-chatbot" */ "../node_modules/sb_chatbot_ui/elements/app-chatbot.js"
    ).then(() => {
      console.debug("app-chatbot import loaded!!!");
    });

    if (userType === "RETAIL") {
      import(
        /* webpackIgnore: "elements-retail" */ "./elements-retail.js"
      ).then(() => {
        console.debug("retail import loaded!!!");
      });
    } else if (userType === "CORP") {
      import(/* webpackIgnore: "elements-corp" */ "./elements-corp.js").then(
        () => {
          console.debug("corporate import loaded!!!");
        }
      );
      if (
        config.SpeedBoat.App.ActiveChatbot &&
        config.SpeedBoat.App.ActiveChatbot.enabled == true
      ) {
        var mbody = document.getElementById("mainbody");
        mbody.chatbot = true;
        import(
          /* webpackChunkName: "app-chatbot" */ "../node_modules/speedboat_ui/elements/chatbot-window.js"
        ).then(() => {
          console.debug("app-chatbot import loaded!!!");
        });
      }
    } else {
      // addImportLink('./elements/elements-speedup.js', true, function () {
      //     console.debug('speedup async import loaded!!!');
      // });
      import(
        /* webpackChunkName: "elements-speedup" */ "./elements-speedup.js"
      ).then(() => {
        console.debug("speedup async import loaded!!!");
      });
      // addImportLink('./elements/elements-common-speedup.js', true, function () {
      //     console.debug('speedup async import loaded!!!');
      // });
      import(
        /* webpackChunkName: "elements-common-speedup" */ "./elements-common-speedup.js"
      ).then(() => {
        console.debug("speedup async import loaded!!!");
      });
      // addImportLink('./node_modules/speedboat_ui/elements/elements-dashboard.js', false, function () {
      //     console.debug('retail dashboard elements import loaded!!!');
      // });
      import(
        /* webpackChunkName: "elements-dashboard" */ "../node_modules/speedboat_ui/elements/elements-dashboard.js"
      ).then(() => {
        console.debug("retail dashboard elements import loaded!!!");
      });
      // addImportLink('./elements/elements-corporate-speedup.js', true, function () {
      //     console.debug('speedup async import loaded!!!');
      // });
      import(
        /* webpackChunkName: "elements-corporate-speedup" */ "./elements-corporate-speedup.js"
      ).then(() => {
        console.debug("speedup async import loaded!!!");
      });
      // addImportLink('./node_modules/speedboat_ui/elements/corporate-dashboard.js', false, function () {
      //     console.debug('corp dashboard elements import loaded!!!');
      // });
      import(
        /* webpackChunkName: "corporate-dashboard" */ "../node_modules/speedboat_ui/elements/corporate-dashboard.js"
      ).then(() => {
        console.debug("corp dashboard elements import loaded!!!");
      });
    }
  });
  document.addEventListener(
    "backbutton",
    function (e) {
      console.log(window.location.pathname);
      e.preventDefault();
      var ironPage = document.querySelector("#preLoginIronPages");
      var currentComponent = ironPage.children[ironPage.selected];
      var leftAction = currentComponent.leftAction;
      if (leftAction != undefined && !Array.isArray(leftAction)) {
        var temp = [];
        temp.push(leftAction);
        leftAction = temp;
      }
      if (leftAction) {
        var index = _.findIndex(leftAction, function (i) {
          return (
            i.leftIcon === "icons:arrow-back" ||
            i.leftIcon === "arrow-back" ||
            i.leftIcon === "home"
          );
        });
        if (index !== -1) {
          if (leftAction[index].lefthref) {
            window.oe_navigate_to(leftAction[index].lefthref, {});
            if (routerPolicy && routerPolicy.decideNavigation) {
              routerPolicy.decideNavigation(
                { url: leftAction[index].lefthref },
                function (e) {},
                function (e) {}
              );
            }
          } else if (leftAction[index].leftCallback) {
            if (leftAction[index].leftIcon == "home") {
              if (routerPolicy && routerPolicy.decideNavigation) {
                routerPolicy.decideNavigation(
                  { url: "/login" },
                  function (e) {},
                  function (e) {}
                );
              }
            }
            leftAction[index].leftCallback();
          }
        }
      } else {
      }
      // if (window.location.pathname == "/") {
      //     document.querySelector('app-dialog').$$('#hybrid-logout-paper-dialog').open();
      //     currentComponent.closevisible = false;
      // }
    },
    false
  );

  /* The below code for customer-assist has been mmoved to ev-login to prevent delay and keep ev-login from loading */

  /*document.addEventListener('loadCustomerAssitlogin', function (e) {
        var currentUrl = e.currentTarget.URL;
        var isCustomerAssisturl = false;
        if (currentUrl != undefined) {
            var tempcurrentIndex = currentUrl.indexOf("?OCH_DATA=");
            if (tempcurrentIndex > -1) {
                isCustomerAssisturl = true;
            }
        }
        if (isCustomerAssisturl && document.querySelector("#preLoginIronPages") != undefined) {
            addImportLink('./node_modules/speedboat_ui/elements/customer-assist-login-landing.js', true, function () {
                document.querySelector("#preLoginIronPages").selected = 13;
            });
        }
    }, true);*/

  /* commented webcomponentsReady because this event is not getting fired in vulcanised build so otp page is not getting loaded for cust assist login flow
    document.addEventListener("WebComponentsReady", function (e) {
        document.dispatchEvent(new Event('loadCustomerAssitlogin'));
    }, true);
    */

  /*document.dispatchEvent(new Event('loadCustomerAssitlogin'));*/
};
if (window.location.protocol === "app:" || window.location.protocol === "file:") {
  window.onload();
}
((manager) => {
  let resetBackdrop = () => {
    let overlayForEl = manager._overlays[manager._overlays.length - 1];
    let backdropEl = manager._backdropElement;
    if (!overlayForEl) {
      return;
    }
    let isDialog = overlayForEl.tagName.toLowerCase() === "paper-dialog";
    let isToast = overlayForEl.tagName.toLowerCase() === "paper-toast";
    if (backdropEl && (isDialog || isToast)) {
      overlayForEl.insertAdjacentElement("afterend", backdropEl);
    }
  };
  window.addEventListener("iron-overlay-opened", resetBackdrop);
  window.addEventListener("iron-overlay-closed", resetBackdrop);
})(IronOverlayManager);

// import '../templates/service-request-template-retail.js';
// import '../templates/service-request-template.js';
// import '../templates/corporate-non-fin-creation-template.js';
// import '../templates/corporate-multiselect-inquiry-search-listing-template.js';
// import '../templates/corporate-multiselect-inquiry-listing-template.js';
// import '../templates/corporate-inquiry-listing-template.js';
// import '../templates/corporate-inquiry-search-listing-template.js';
// import '../templates/service-request-specific-api-template.js';
// import '../templates/corporate-inquiry-listing-details-template.js';
// import '../templates/service-request-specific-api-template.js';
// import '../templates/corporate-inquiry-listing-details-template.js';
// import '../templates/approval-template.js';
// import '../templates/service-request-specific-api-template-retail.js';
// import '../templates/create-listing-retail-template.js';
// import '../templates/corporate-linkage-template.js';
// import '../templates/retail-details-template.js';
// import '../templates/service-request-summary-template.js';
// import '../templates/retail-modify-template.js';
// import '../templates/filter-template.js';
// import '../templates/corporate-inquiry-listing-details-template-vam.js';
// import '../templates/corporate-search-listing-template.js';
// import '../templates/corporate-listing-details-template.js';
// import '../templates/corporate-listing-dynamic-accordion-template.js';
// import '../templates/corporate-listing-without-search-template.js';
// import '../templates/request-approval-template.js';
// import '../templates/next-approver-template.js';
